<template>
  <div class="comContent">
    <div class="topHead">
      <div>
        <span>{{ shopName }}</span>
        <span style="margin-left: 12px;color: black;font-size: 14px;font-weight: 600;">
          当前余额
          <span style="color: #F5222D;">
            ￥ {{ (lockAmount + useAmount) | filterMoney }}
          </span>
        </span>
        <span style="margin-left: 12px;color: black;font-size: 14px;font-weight: 600;">
          订单占用余额
          <span style="color: #F5222D;">
            ￥ {{ lockAmount | filterMoney }}
          </span>
        </span>
        <span style="margin-left: 12px;color: black;font-size: 14px;font-weight: 600;">
          当前可用余额
          <span style="color: #F5222D;">
            ￥ {{ useAmount | filterMoney }}
          </span>
        </span>
      </div>
      <div>
        <el-button size="small" type="primary" @click="HandlerClick('保证金扣减', '1')">保证金扣减</el-button>
        <el-button size="small" type="primary" @click="HandlerClick('保证金增额', '0')">保证金增额</el-button>
      </div>
    </div>
    <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left;margin-top: 20px;">
      <el-form-item prop="orderId" label="">
        <el-input v-model.trim="formTool.orderId" placeholder="请输入订单编号" clearable size="small" />
      </el-form-item>
      <el-form-item prop="extendType" label="">
        <el-select v-model="formTool.reason" clearable style="width: 160px;" size="small" placeholder="保证金变动原因">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="extendType" label="">
        <el-date-picker v-model="date" size="small" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset()">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="exportUrl()">导出</el-button>
      </el-form-item>
    </el-form>

    <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
      :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
      <template slot="status" slot-scope="scope">
        {{ scope.row.reason | filterReasonType }}
      </template>
      <template slot="promotionArea" slot-scope="scope">
        <span v-if="scope.row.type == 1" class="add"> + <span> {{ scope.row.amount ?
          parseFloat(scope.row.amount).toFixed(2) : '0.00' }}</span></span>
        <span v-if="scope.row.type == 2" class="reduce"> - <span>{{ scope.row.amount ?
          parseFloat(scope.row.amount).toFixed(2) : '0.00' }}</span></span>
        <br />
        <span> <span> {{ scope.row.useAmount ? parseFloat(scope.row.useAmount).toFixed(2) : '0.00' }}</span> </span>
      </template>
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link type="primary" :underline="false" @click="detailClick(scope.row, '保证金详情')" style="margin-right: 10px">
            详情
          </el-link>
        </div>
      </template>
    </myTable>
    <deductionDialog ref="deductionDialog" @submit="submit" />
    <detailDialog ref="detailRef"></detailDialog>
  </div>
</template>
<script>

const options = [
  {
    value: '1',
    label: '保证金充值'
  },
  {
    value: '2',
    label: '订单资金冻结'
  },
  {
    value: '3',
    label: '服务费扣除'
  }, {
    value: '4',
    label: '售后资金扣减'
  }, {
    value: '5',
    label: '订单资金解冻'
  },
  {
    value: '6',
    label: '超时赔付'
  },
  {
    value: '7',
    label: '服务费冻结'
  },
  {
    value: '8',
    label: '服务费解冻'
  },
  {
    value: '9',
    label: '订单超时赔付金额冻结'
  },
  {
    value: '10',
    label: '订单超时赔付金额解冻'
  },
  {
    value: '11',
    label: '订单超时赔付金额扣减'
  },
  {
    value: '12',
    label: '平台增额'
  },
  {
    value: '13',
    label: '平台扣减'
  },
]
import myTable from "@/components/myTable";
import deductionDialog from "../component/deductionDialog.vue";
import detailDialog from "../component/detailDialog.vue";
import { userLogPage, fileExport, guaranteeInfo, manualUpdateCustoms } from "@/api/gift";
export default {
  components: { myTable, deductionDialog, detailDialog },
  props: {},
  data () {
    return {
      useAmount: null,
      lockAmount: null,
      stopThreshold: null,
      shopId: '',
      shopName: '',
      date: '',
      value1: [],
      options: options,
      expanded: false,
      isExpanded: false,
      loading: false,
      operation: true,
      selection: true,
      index: true,
      formTool: {},
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        // { label: "记录编号", prop: "shopName", },
        // { label: "运营人员&联系方式", prop: "shopName", },
        { label: "变动时间", prop: "createTime", },
        { label: "变动原因", prop: "status", slot: true },
        { label: "订单编号", prop: "orderNo", },
        // { label: "赠品数量", prop: "qty", },
        { label: "收支/余额（元）", prop: "promotionArea", slot: true },
        // { label: "促销开始时间", prop: "startTime", },
        // { label: "促销结束时间", prop: "endTime", },
        // { label: "添加时间", prop: "createTime", },
        // { label: "审核状态", prop: "status", slot: true },
        { label: "操作", prop: "operation", slot: true, width: 100 },
      ],
    };
  },
  filters: {
    filterReasonType (e) {
      for (let i = 0; i < options.length; i++) {
        if (e == options[i].value) return options[i].label
      }
    },
    filterMoney (e) {
      return e ? parseFloat(e).toFixed(2) : '0.00';
    },
  },
  created () {
    if (this.$route.query.shopId) {
      this.shopId = this.$route.query.shopId
    }
    if (this.$route.query.shopName) {
      this.shopName = this.$route.query.shopName
    }
  },
  mounted () {
    this.getList();
    // this.guaranteeInfo()
  },
  methods: {
    guaranteeInfo () {
      let params = {
        shopId: this.shopId
      }
      guaranteeInfo(params).then(res => {
        this.useAmount = res.useAmount;
        this.lockAmount = res.lockAmount;
        this.oriAmount = res.oriAmount;
        this.stopThreshold = res.stopThreshold;//停用阈值
      })
    },
    // 提交
    submit (value) {
      let params = {
        amount: value.amount,
        remark: value.remark,
        changeAmountType: value.type,
        shopId: this.shopId,
        // customShopName: this.shopName
      }
      manualUpdateCustoms(params).then((res) => {
        if (res) {
          this.$message.success('操作成功')
          this.getList();
          // this.guaranteeInfo()
          this.$refs.deductionDialog.handleClose()
        }
      })
    },
    // 选择商品
    chooseGood (row) {
      this.dialogVisible = true;
      this.rowData = row;
    },
    choice (val) {
      this.rowData.skuList = val
      // this.beforeClose()
    },
    getList (current) {
      if (current) {
        this.page.current
      }
      if (current) {
        this.page.current = current;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };
      if (this.date) {
        params.startCreateTime = this.date[0];
        params.endCreateTime = this.date[1];
      }
      if (this.shopId) {
        params.shopId = this.shopId
      }
      this.guaranteeInfo()
      userLogPage(params).then((res) => {
        // console.log(res, '--res')
        this.tableData = res.records;
        this.page.total = res.total;
      }).catch((err) => { })
    },

    goBack () {
      this.$router.back()
    },
    UpdateStatus () {

    },
    HandlerClick (title, type) {
      // this.$router.push(`./salesControl-fullGiftOps-giftDetail?id=${row.id}&type=${type}`);
      this.$refs.deductionDialog.open(title, type)
    },
    // 详情
    detailClick (row, title) {
      this.$refs.detailRef.open(row, title)
    },
    reset () {
      this.date = ''
      this.formTool = {}
      this.getList(1)
    },
    exportUrl () {
      const params = {
        ...this.formTool,
        shopId: this.shopId
      };
      if (this.date) {
        params.startCreateTime = this.date[0];
        params.endCreateTime = this.date[1];
      }
      delete params.date;
      fileExport('/payment/guarantee/merchant/userLogExport', 'POST', params).then((res) => { }).catch((err) => {

      })
    },
  },
};
</script>
<style lang="scss" scoped>
.reduce {
  color: green;
}

.add {
  color: #F5222D;
}

.topHead {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep.el-table {
  height: calc(100% - 190px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 170px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.expand-form {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.flex-box {
  display: flex;
  justify-content: space-between;
}
</style>
